import { useState, useEffect } from 'react';
import { useEstablishmentStore } from '../../store/establishmentStore';
import { useAuth } from '../../context/AuthContextZustand';

export const useBusinessHoursCheck = () => {
  const { user } = useAuth();
  const { establishment } = useEstablishmentStore();
  const [hasBusinessHours, setHasBusinessHours] = useState<boolean | null>(null);

  useEffect(() => {
    if (!user || !user.permissions?.includes('iam.manage')) {
      setHasBusinessHours(null);
      return;
    }

    // Usar dados do store do estabelecimento (já carregados quando entra na página)
    if (establishment) {
      // Verificar se há weeklyOperatingHours configurados
      const hasWeeklyHours =
        establishment.weeklyOperatingHours &&
        Object.values(establishment.weeklyOperatingHours).some(
          (day: unknown) => day && typeof day === 'object' && 'open' in day && 'close' in day
        );

      setHasBusinessHours(!!hasWeeklyHours);
    } else {
      // Se não tem dados do estabelecimento ainda, assumir que não tem horários
      setHasBusinessHours(false);
    }
  }, [user, establishment]);

  return {
    hasBusinessHours,
    needsBusinessHours: hasBusinessHours === false,
  };
};
